module.exports = __webpack_public_path__ + "img/p_bemove.94416312.png";